import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';
import { IntlService } from '@progress/kendo-angular-intl';
import { BaseCardComponent } from "./base-card.component";
import { AuthService } from '@app/core/services';
import { Router } from '@angular/router';


@Component({
  selector: 'credit-card',
  styleUrls: ['./styles/styles-card.css'],
  styles: [`
    .card{
      height: 90px;
    }        
  `],
  template: `
    <!--{{customer | json}}-->
    <div class="card" [class.border-top]="borderTop" (click)="selectItem($event)">
      <kendo-avatar [imageSrc]="defaultImage" shape="circle" style="background-size: contain; padding: 6px; background-color: #2ecc71"></kendo-avatar>
      <div class="card-details">
        
        <div class="card-subtitle no-wrap">
          {{ credit.rfc }}<span class="right">Créditos: {{ credit.credit_total }}</span>
        </div>
        <div class="card-subtitle no-wrap">
          {{ credit.name }}
        </div>
        <div class="card-subtitle no-wrap">
          Por vencer: <span class="right">{{ intl.formatNumber(credit.credit_total_due, "c2", "en") }}</span>
        </div>
        <div class="card-subtitle no-wrap">
          Vencido: <span class="right">{{ intl.formatNumber(credit.credit_total_overdue, "c2", "en") }}</span>
        </div>
        <div class="card-title">
          Saldo: <span class="right">{{ intl.formatNumber(credit.credit_total_pending, "c2", "en") }}</span>
        </div>
      </div>
      <div class="card-actions" *ngIf="authService.hasPermission(['CREDITOS:EDITAR','CREDITOS:ELIMINAR'])">
        <span class="k-icon k-icon-md k-i-arrow-chevron-right k-color-secondary" style="color: #2ecc71!important"></span>
      </div>
    </div>
  `,    
})
export class CreditCardComponent extends BaseCardComponent {

  @Input() credit!: any;

  @Input() defaultImage: string = environment.assets.DEFAULT_CUSTOMER;

  @Input() returnUrl: string;


  constructor(public intl: IntlService, public router: Router, public authService: AuthService) { 

    super(intl, router)

  }

  public selectItem(event: any) {

    this.router.navigate(['/customer_credits/' + this.credit.id], {state: {returnUrl: this.returnUrl}});

  }

}